<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('instagram.add-comment')"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row class="justify-content-center">
        <b-col
          md="8"
          sm="12"
        >
          <ok-text-input
            v-model="form.message"
            textarea
            is-required
            :label="$t('instagram.comment-message')"
          />
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.send') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import InstagramMediaApi from '@/api/instagram/media'
import ReplyApi from '@/api/reply'

export default {
  name: 'CommentModal',
  components: {
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkModal,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    instagram: {
      type: Boolean,
      default: true,
    },
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      form: {
        message: '',
      },
      loading: false,
    }
  },
  methods: {
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { ...this.form }
        const pageId = this.$store.getters[(this.instagram) ? 'instagram/currentAccountId' : 'pages/currentPageId']
        if (!this.instagram) {
          form.post_id = this.post.id
          form.page_id = pageId
        }
        await (this.instagram ? InstagramMediaApi.leaveComment(this.post.id, pageId, form) : ReplyApi.leaveComment(form)).then(res => {
          if (res.error === 0) {
            this.$swal({
              position: 'center',
              icon: 'success',
              html: res.message,
              showConfirmButton: true,
              showCancelButton: false,
            })
            this.$emit('commented')
            this.form.message = ''
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
